import { render, staticRenderFns } from "./imageCarousel.vue?vue&type=template&id=008fe624&"
import script from "./imageCarousel.vue?vue&type=script&lang=js&"
export * from "./imageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('008fe624')) {
      api.createRecord('008fe624', component.options)
    } else {
      api.reload('008fe624', component.options)
    }
    module.hot.accept("./imageCarousel.vue?vue&type=template&id=008fe624&", function () {
      api.rerender('008fe624', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2dfpK4DzfU6f6/JS/imageCarousel.vue"
export default component.exports